<template>
  <div
    ref="card"
    class="spotlight-card"
    @mousemove="handleMouseMove"
    @mouseenter="opacity = 0.6"
    @mouseleave="opacity = 0"
  >
    <div
      class="spotlight-card__overlay"
      :style="{
        opacity: opacity,
        background: 'radial-gradient(circle at ' + position.x + 'px ' + position.y + 'px, ' + spotlightColor + ', transparent 80%)'
      }"
    ></div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SpotlightCard',
  props: {
    spotlightColor: {
      type: String,
      default: 'rgba(72, 187, 120, 0.25)'
    }
  },
  data () {
    return {
      position: { x: 0, y: 0 },
      opacity: 0
    }
  },
  methods: {
    handleMouseMove (e) {
      if (!this.$refs.card) return
      const rect = this.$refs.card.getBoundingClientRect()
      this.position = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      }
    }
  }
}
</script>

<style scoped>
.spotlight-card {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
}

.spotlight-card__overlay {
  pointer-events: none;
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  z-index: 1;
}
</style>
